import { FilterElement, InputGroupV2, UniversalSelect } from '@equip.health/ui';

import { formatOptionLabel } from '~/lib/util/inquiry.util';

interface SelectFilterProps {
  ariaLabel: string;
  id: string;
  inputValue: string;
  isLoading?: boolean;
  isSearchable?: boolean;
  isSingleSelect?: boolean;
  label: string;
  onChange: (status: FilterElement[]) => void;
  placeholder: string;
  options: ProviderOption[];
  value: FilterElement[];
  withCheckBox?: boolean;
}
const SelectFilter = ({
  ariaLabel,
  id,
  isSearchable = true,
  isSingleSelect = false,
  label,
  onChange,
  placeholder = 'Search',
  options,
  value,
  withCheckBox = true,
}: SelectFilterProps) => {
  const TOP_LEVEL_ID = `${id}__select-filter`;
  return (
    <InputGroupV2 id={`${TOP_LEVEL_ID}__group`} label={label}>
      <UniversalSelect
        ariaLabel={ariaLabel}
        formatOptionLabel={formatOptionLabel}
        id={TOP_LEVEL_ID}
        isSearchable={isSearchable}
        isSingleSelect={isSingleSelect}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        value={value}
        withCheckBox={withCheckBox}
      />
    </InputGroupV2>
  );
};

export default SelectFilter;
